import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/cn";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn("flex flex-1 flex-col items-center justify-center px-8 py-16", className)}>
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-surface)]">
        <Icon className="h-8 w-8 text-[var(--color-text-muted)]" />
      </div>

      <h2 className="mb-2 text-lg font-semibold text-[var(--color-text)]">{title}</h2>

      <p className="mb-6 max-w-64 text-center text-sm text-[var(--color-text-secondary)]">
        {description}
      </p>

      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="rounded-[var(--radius-md)] bg-[var(--color-primary)] px-6 py-2.5
                     text-sm font-medium text-white transition-colors
                     hover:bg-[var(--color-primary-hover)] active:scale-[0.97]"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
